module.exports = __webpack_public_path__ + "img/Course-Card-Done-Right.53370926.png";